import React from 'react'
import { object, array } from 'prop-types'

import Category from '@/components/Category'
import SEO from '@/components/SEO'
import EnhancedListProvider from '@/context/EnhancedList'
import { SORT, FILTERS, URLS } from '@/constants'
import Layout from '@/layout'

const sortOptions = Object.values(SORT)

const CampaignTemplate = ({ campaign, products }) => {
  if (!campaign) {
    return null
  }

  const campaignApplications = campaign?.applications.map((app) => app.id)

  // Filter by campaign and convert apps to have the same structure as redux store
  const campaignApps = products?.filter((app) => {
    return campaignApplications?.includes(app.id)
  })

  const category = {
    slug: campaign?.id,
    name: campaign?.name,
  }

  const supportedFilters = [
    FILTERS.CATEGORY.ID,
    FILTERS.PAYMENT.ID,
    'sortBy',
    FILTERS.COMPATIBILITY.ID,
  ]

  // We are using Category component due to similar content and limitations.
  return (
    <EnhancedListProvider
      items={campaignApps}
      defaultSortValue={SORT.RECOMMENDED.VALUE}
      defaultSortOptions={sortOptions}
      supportedFilters={supportedFilters}
    >
      <Layout category={category} headerLabel={campaign?.name}>
        <SEO
          title={`${process.env.GATSBY_PRODUCT_LABEL} for ${campaign?.name} | ${
            process.env.GATSBY_PRODUCT_LABEL
          } - ${campaign?.name} ${
            campaign.name === URLS.APPS.LABEL ? ' ' : ' apps'
          } and integrations | Add chat to ${campaign?.name} software`}
          description={
            campaign?.description ||
            `Extend your ${
              process.env.GATSBY_PRODUCT_LABEL
            } with powerful features to get your work done faster.`
          }
        />
        <Category
          name={campaign?.name}
          headline={campaign?.description}
          campaign={campaign}
        />
      </Layout>
    </EnhancedListProvider>
  )
}

CampaignTemplate.propTypes = {
  campaign: object,
  products: array,
}

export default CampaignTemplate
